module.exports = "/_next/static/images/OnboardingMobile-b07d226638b83f6d693e96c5a295a518.png";